import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { ChevronLeft, ChevronRight, Quote, Star } from "lucide-react";

import Avatar from "../../Avatar/Avatar";
import Container from "../../Container/Container";
import SectionTitle from "../../SectionTitle/SectionTitle";
import { testimonials } from "../../../Data/testimonialsData";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "../../../Style/home/testimonials.css";

function Testimonials() {
  return (
    <section className="section section--gradient testimonials">
      <Container>
        <SectionTitle eyebrow="Testimonials" title="What clients" highlight="say." align="center" />

        <div className="testimonials__carousel">
          <Swiper
            modules={[Autoplay, Navigation, Pagination]}
            slidesPerView={1}
            spaceBetween={24}
            loop
            autoplay={{ delay: 5500, disableOnInteraction: false }}
            navigation={{ prevEl: ".testimonials__nav--prev", nextEl: ".testimonials__nav--next" }}
            pagination={{ clickable: true, el: ".testimonials__pagination" }}
            breakpoints={{ 768: { slidesPerView: 2 }, 1100: { slidesPerView: 3 } }}
          >
            {testimonials.map((testimonial) => (
              <SwiperSlide key={testimonial.id}>
                <div className="card testimonials__card">
                  <Quote size={28} className="testimonials__quote-icon" />
                  <p className="testimonials__text">"{testimonial.quote}"</p>

                  <div className="testimonials__stars">
                    {Array.from({ length: 5 }).map((_, index) => (
                      <Star
                        key={index}
                        size={15}
                        fill={index < testimonial.rating ? "currentColor" : "none"}
                      />
                    ))}
                  </div>

                  <div className="testimonials__author">
                    <Avatar name={testimonial.name} size="sm" />
                    <div>
                      <p className="testimonials__name">{testimonial.name}</p>
                      <span className="testimonials__role">
                        {testimonial.role}, {testimonial.company}
                      </span>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          <div className="testimonials__controls">
            <button type="button" className="testimonials__nav testimonials__nav--prev" aria-label="Previous testimonial">
              <ChevronLeft size={18} />
            </button>
            <div className="testimonials__pagination" />
            <button type="button" className="testimonials__nav testimonials__nav--next" aria-label="Next testimonial">
              <ChevronRight size={18} />
            </button>
          </div>
        </div>
      </Container>
    </section>
  );
}

export default Testimonials;
